/**
 * The header's way into the watchlist (roadmap §11.5): how many of the things you follow have
 * something open, a click from the dropdown that lists them.
 */
import type { ReactNode } from 'react';
import { Icon } from '@/components/lumen/Icon';
import { useWatchlist } from '@/lib/api/watchlist';

export function WatchlistButton({ open, onToggle }: { open: boolean; onToggle: () => void }): ReactNode {
  const list = useWatchlist();
  const items = list.data ?? [];
  const busy = items.filter((w) => w.open > 0).length;
  const critical = items.some((w) => w.worst === 'critical');
  const label =
    items.length === 0 ? 'Watchlist — nothing followed yet' : `Watchlist — ${items.length} followed${busy > 0 ? `, ${busy} with something open` : ', all quiet'}`;
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      aria-haspopup="dialog"
      data-hd-trigger="watchlist"
      aria-label={label}
      title={label}
      className="lm-hov relative flex items-center gap-[6px] rounded-[var(--radius-sm)] px-[8px]"
      style={{ height: 'var(--header-ctl-h)', color: busy > 0 ? 'var(--fg)' : 'var(--muted-fg)' }}
    >
      <Icon name="ic-star" size={15} {...(items.length > 0 ? { className: 'lm-icon-fill' } : {})} />
      {busy > 0 && (
        <span
          className="lm-num flex min-w-[17px] items-center justify-center rounded-[var(--radius-pill)] px-[4px] text-[10px] font-bold"
          style={{ background: critical ? 'var(--danger)' : 'var(--warn)', color: 'var(--primary-fg)' }}
        >
          {busy}
        </span>
      )}
    </button>
  );
}
